export const FAVORITE_STORAGE_KEY = "FAVORITE_STORAGE_KEY";
